//to view all the action types in a single place

export const DO_ALERT = 'DO_ALERT';
export const UNDO_ALERT = 'UNDO_ALERT';
export const SIGNUP_SUCESS = 'SIGNUP_SUCESS';
export const SIGNUP_FAIL = 'SIGNUP_FAIL';
export const USER_AUTHENTICATED = 'USER_AUTHENTICATED';
export const AUTHENTICATION_ERROR = 'AUTHENTICATION_ERROR';
export const LOGIN_SUCESS = 'LOGIN_SUCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGGING_OUT = 'LOGGING_OUT';
export const GET_FREELANCERPROFILE = 'GET_FREELANCERPROFILE';
export const FREELANCERPROFILE_ERROR = 'FREELANCERPROFILE_ERROR';
export const EMPTY_PROFILE = 'EMPTY_PROFILE';
export const GET_BUSINESSPROFILE = 'GET_BUSINESSPROFILE';
export const BUSINESSPROFILE_ERROR = 'BUSINESSPROFILE_ERROR';
export const EMPTY_BUSINESSPROFILE = 'EMPTY_BUSINESSPROFILE';
export const BUSINESSSIGNUP_SUCESS = 'BUSINESSSIGNUP_SUCESS';
export const BUSINESSSIGNUP_FAIL = 'BUSINESSSIGNUP_FAIL';
export const BUSINESS_AUTHENTICATED = 'BUSINESS_AUTHENTICATED';
export const BUSINESSAUTHENTICATION_ERROR = 'BUSINESSAUTHENTICATION_ERROR';
export const UPDATE_FREELANCERPROFILE = 'UPDATE_FREELANCERPROFILE';
export const BUSINESSLOGIN_SUCESS = 'BUSINESSLOGIN_SUCESS';
export const BUSINESSLOGIN_FAIL = 'BUSINESSLOGIN_FAIL';
export const BUSINESSLOGGING_OUT = 'BUSINESSLOGGING_OUT';
export const GET_ALLPROFILES = 'GET_ALLPROFILES';
export const CLEAR_FREELANCERPROFILE = 'CLEAR_FREELANCERPROFILE';
export const GITHUB_DATA = 'GITHUB_DATA';
export const GET_JOBS = 'GET_JOBS';
export const GET_JOB = 'GET_JOB';
export const JOBS_ERROR = 'JOBS_ERROR'; 
export const UPDATE_INTERESTED = 'UPDATE_INTERESTED'; 
export const ADD_JOBS = 'ADD_JOBS';
export const UPDATE_JOBS = 'UPDATE_JOBS'; 






